import { Subject, Subscription } from 'rxjs';
import { Injectable } from '@angular/core';
import { Logger } from './logger';

let _instance = null;

@Injectable()
export class ModelRegistry {
    constructor() {
        _instance = this;
    }

    private static modelClasses: any = {};

    public static setInstanceForTest(value: any) {
        _instance = value;
    }

    public static instance(): ModelRegistry {
        if (!_instance)
            throw "ModelRegistrar is not yet ready (wait for Angular to boot, ensure AppComponent injects ModelRegistrar)";

        return _instance;
    }

    private static _ready = false;
    private static _readyChanged: Subject<boolean> = new Subject<boolean>();

    static ready(): Promise<void> {

        if (this._ready)
            return Promise.resolve();

        return new Promise<void>((resolve, reject) => {
            let sub: Subscription = null;

            if (this._ready) {
                resolve();
                return;
            }

            sub = this._readyChanged.subscribe(() => {
                sub.unsubscribe();
                resolve();
            });
        });
    }

    static registerModel(cls: Function, modelName?: string) {
        if (!modelName)
            modelName = cls.name;

        this.modelClasses[modelName] = cls;
    }

    init() {
        ModelRegistry._ready = true;
        ModelRegistry._readyChanged.next(true);
    }

    /**
     * Do a reverse look up, finding the unmangled model class name
     * that corresponds with the given model type. Returns null if
     * no corresponding model name is found.
     * @param type The model type (constructor function) to look up
     */
    static getNameForClass(type: Function): string {
        for (let key in this.modelClasses) {
            if (this.modelClasses[key] === type)
                return key;
        }

        return null;
    }

    /**
     * Inflate data into a rich model, indirectly.
     * @param clsName
     * @param data
     */
    static inflate(clsName: string, data: any): any {
        try {
            if (clsName && clsName.length > 0 && clsName.length < 3) {
                Logger.failure(`Failed to recover from name mangling. Cannot expand model of type '${clsName}'`);
            }

            if (data === null || data === undefined)
                return data;

            clsName = clsName.replace(/Abbreviated/, '').replace(/^Api/, '');

            let cls = this.modelClasses[clsName];

            if (!cls) {
                // Attempt to find an API model for it instead
                cls = this.modelClasses[`Api${clsName}`];
            }

            if (!cls) {
                Logger.info(`No model (or API model) registered with name ${clsName}, will expand to plain old object.`);
                return data;
            }

            if (data instanceof Array) {
                return data.map(x => new cls(x));
            } else {
                return new cls(data);
            }
        } catch (e) {
            console.error(`Failed while expanding API data into model of type ${clsName}`);
            console.log(`Raw data:`);
            console.dir(data);
            console.error(e);
            throw new Error(`Failed to expand model data with type ${clsName}`);
        }
    }
}